














































import { Vue, Component, Prop } from 'vue-property-decorator'
import Bubble from '../Bubble.vue'
import ClickOutside from 'v-click-outside'
import { Select, SelectOption } from '@alpha/ink'
import store from '@/store'
import { Test } from '@shared/types/database'
import analytics from '@/analytics'
import EditBubble from './EditBubble.vue'
import HoverBox from './HoverBox.vue'

@Component({
  components: {
    Bubble,
    Select,
    EditBubble,
    HoverBox
  },
  directives: { clickOutside: ClickOutside.directive }
})
export default class Tags extends Vue {
  @Prop({ required: true }) readonly test!: Test
  @Prop({ required: true }) readonly tags!: string[]
  @Prop({ default: false }) readonly tagsUpdating!: boolean

  showList = false
  showCount = 6
  showMore = false

  get unselectedWorkspaceTagOptions (): SelectOption[] {
    return store.getters.workspace.tags
      .filter(tag => !this.tags.includes(tag))
      .map(tag => ({
        label: tag,
        value: tag
      }))
  }

  get selectedTagOptions (): SelectOption[] {
    return this.tags.map(tag => ({
      label: tag,
      value: tag
    }))
  }

  addTag (tag: string) {
    analytics.track('Tag Added', { testId: this.test.id })
    const tags = this.tags.concat([tag])
    this.$emit('tagsUpdated', tags)
  }

  input (tagOptions: SelectOption[]) {
    const tags = tagOptions.map(option => option.value ? option.value.toString() : null).filter(Boolean)
    this.$emit('tagsUpdated', tags)
  }

  toggle () {
    this.showList = !this.showList
  }

  close () {
    this.showList = false
  }
}
